import { t } from "../../i18n";
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';
import createPortalTheme from '../../themes';
import { portalConfig } from '../../configs/portal';
import Sidebar from './Sidebar';
import Header from './Header';
const portalTheme = createPortalTheme({
  borderRadius: 12,
  navType: 'light'
});
function LayoutContent() {
  const desktop = useMediaQuery(portalTheme.breakpoints.up('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);
  useEffect(() => {
    setDrawerOpen(false);
  }, [desktop]);
  return <Box sx={{
    display: 'flex',
    minHeight: '100dvh',
    bgcolor: 'primary.light'
  }}>
            <Sidebar desktop={desktop} drawerOpen={desktop || drawerOpen} onClose={() => setDrawerOpen(false)} onNavigate={() => {
      if (!desktop) setDrawerOpen(false);
    }} />
            <Box sx={{
      flex: 1,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column'
    }}>
                <Header desktop={desktop} drawerOpen={drawerOpen} onDrawerToggle={() => setDrawerOpen(open => !open)} />
                <Box component="main" id="main-content" tabIndex={-1} sx={{
        flex: 1,
        minWidth: 0,
        minHeight: `calc(100dvh - ${portalConfig.headerHeight}px)`,
        p: {
          xs: 2,
          sm: 3
        },
        outline: 'none'
      }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>;
}
export default function MainLayout() {
  return <ThemeProvider theme={portalTheme}>
            <Box component="a" href="#main-content" sx={{
      position: 'fixed',
      top: -80,
      left: 16,
      zIndex: 'tooltip',
      p: 1.5,
      bgcolor: 'background.paper',
      color: 'primary.main',
      '&:focus': {
        top: 8
      }
    }}>{t("Saltar para o conteúdo")}</Box>
            <LayoutContent />
        </ThemeProvider>;
}
